import { api } from '@/services/api/AxiosBaseService'
import type { SingleResponse } from '@/types/api'

export interface AdminDashboard {
  yearlyPaid: { year: number; total: number; growthPct: number | null }[]
  currentMonth: {
    pending: { count: number; total: number }
    paid: { count: number; total: number }
    commissions: {
      total: { count: number; amount: number }
      firstLevel: { count: number; amount: number }
      network: { count: number; amount: number }
    }
  }
  monthlyAdhesions: { month: string; label: string; count: number }[]
  paymentMethods: { method: string; count: number }[]
  activeSubscriptions: {
    total: number
    byType: { type: string; total: number }[]
  }
  latestCompanies: {
    id: string
    name: string
    cpfCnpj: string | null
    status: string
    createdAt: string | null
    formatted: { createdAt: string | null }
  }[]
  latestSubscribers: {
    id: string
    name: string
    code: string | null
    planName: string | null
    status: string
    createdAt: string | null
    formatted: { createdAt: string | null }
  }[]
}

export const DashboardService = {
  async admin(): Promise<AdminDashboard> {
    const r = await api.get<SingleResponse<AdminDashboard>>('/dashboard/admin')
    return r.data.data
  },
}
